import { AppSubscriptionKey } from '../model/enums/appSubscriptionKey'
import { AppConfigurationItemModel } from '../redux'
import { envConfig } from './envConfig'

export const getSubscriptionKeys = (): AppConfigurationItemModel[] => {
  return [{ key: AppSubscriptionKey.FrontSubscription, value: envConfig.subscriptions.front }]
}
